import { FC, SyntheticEvent, useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import ProfilesTable from './ProfilesTable'
import ProfilesEditModal from './ProfilesEditModal'

const ProfilesList: FC = () => {
  const [itemIdForUpdate, setItemIdForUpdate] = useState<string>('')
  const [refreshFunction, setRefreshFunction] = useState<any>(() => {})

  return (
    <>
      <ProfilesTable
        enablePolling={true}
        pollingInterval={5000}
        onEdit={(id: any, refresh: Function) => {
          setRefreshFunction(() => refresh)
          setItemIdForUpdate(id)
        }}
        onDelete={(id: any, refresh: Function) => {
          axios.get('/profiles/save/' + id).then((response) => {
            let csrfData = response.data.data
            Swal.fire({
              title: 'Warning',
              html: 'Are you want to delete this profile?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Delete',
              cancelButtonText: 'Cancel',
              customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'btn btn-primary',
              },
            }).then((result) => {
              if (result.isConfirmed) {
                axios
                  .delete('/profiles/save/' + id, {
                    data: csrfData,
                  })
                  .then(() => {
                    refresh()
                  })
              }
            })
          })
        }}
        onAdd={(_event: SyntheticEvent, refresh: Function) => {
          setItemIdForUpdate('add')
          setRefreshFunction(() => refresh)
        }}
      />
      {itemIdForUpdate !== '' ? (
        <ProfilesEditModal
          show={itemIdForUpdate !== ''}
          itemIdForUpdate={itemIdForUpdate}
          onHide={() => {
            setItemIdForUpdate('')
          }}
          refreshFunction={(itemId: any) => {
            if (itemId !== undefined) {
              setItemIdForUpdate(itemId)
            }
            refreshFunction()
          }}
        />
      ) : (
        <></>
      )}
    </>
  )
}

export default ProfilesList
